// extracted by mini-css-extract-plugin
export default {"group":"SearchInput_group__qyG1U","icon":"SearchInput_icon__34eoK","input":"SearchInput_input__YPjsM"};